import Box from "@material-ui/core/esm/Box";
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import Radio from "@material-ui/core/esm/Radio";
import RadioGroup from "@material-ui/core/esm/RadioGroup";
import { nanoid } from 'nanoid';
import React, { useEffect, useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { vehicleInformation as vehicleInformationAtom } from 'api/vehicles/getVehicleInformation';
import DividerComponent from 'components/Divider/Divider';
import { BoldSubtitle } from 'components/Text';
import VehicleForm from 'components/VehicleForm/VehicleForm';
import { DEFAULT_LANGUAGE } from 'constants/language';
import useTransferTag from 'hooks/tags/useTransferTag';
import { vehicleFormValid as vehicleFormValidAtom } from 'state/vehicles';
export default function ChooseVehicle() {
  const {
    t
  } = useTranslation();
  const vehicleFormIdRef = useRef(nanoid());
  const vehicleFormId = vehicleFormIdRef.current;
  const vehicleForm = useForm({
    defaultValues: {
      nationality: DEFAULT_LANGUAGE
    },
    mode: 'onChange'
  });
  const {
    tag,
    setVehicle,
    changeVehicle,
    setChangeVehicle
  } = useTransferTag();
  const vehicleInformation = useRecoilValue(vehicleInformationAtom(vehicleFormId));
  const vehicleFormValid = useRecoilValue(vehicleFormValidAtom(vehicleFormId));
  useEffect(() => {
    if (!vehicleFormValid) setVehicle(null);else setVehicle(vehicleInformation);
  }, [vehicleFormValid, vehicleInformation, setVehicle]);
  const changeVehicleOnChange = event => {
    setChangeVehicle(event.target.value === 'true');
  };
  useEffect(() => {
    if (!tag?.registrationNumber) setChangeVehicle(true);
  }, [tag, setChangeVehicle]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('transfer_tag.should_change_vehicle'))), /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": "select change vehicle option",
    name: "changeVehicleOption",
    value: changeVehicle ? 'true' : 'false',
    onChange: changeVehicleOnChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "true",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t('transfer_tag.change_vehicle')
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "false",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: tag?.registrationNumber ? t('transfer_tag.keep_vehicle') : t('transfer_tag.keep_inactive')
  })))), changeVehicle && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(BoldSubtitle, null, t('transfer_tag.new_vehicle'), ":"), /*#__PURE__*/React.createElement(Box, {
    mt: 4
  }, /*#__PURE__*/React.createElement(FormProvider, vehicleForm, /*#__PURE__*/React.createElement(VehicleForm, {
    vehicleFormId: vehicleFormId
  })))));
}